import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorpageComponent } from './errorpage/errorpage.component';
import { CommonLayoutComponent } from './pages/common-layout/common-layout/common-layout.component';
import { PageNotFoundComponent } from './pages/login/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('../app/pages/login/login.module').then((m) => m.LoginModule),
    data: { title: 'Login' },
  },
  // { path: "common-layout", loadChildren: () => import('../app/pages/common-layout/common-layout.module').then(m => m.CommonLayoutModule), data: { title: "Common Layout" } },
  {
    path: 'brooklyn',
    component: CommonLayoutComponent,
    data: { title: '' },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/common-layout/common-layout.module').then(
            (m) => m.CommonLayoutModule
          ),
      },
    ],
  },
  { path: 'page-not-found', component: PageNotFoundComponent },
  
  {
    path: 'something-wrong',
    component: ErrorpageComponent,
  },
  {
    path: '**',
    redirectTo: '/page-not-found',
    pathMatch: 'full',
    data: { title: 'Page Not Found' },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
